import { render } from "./xjllb.vue?vue&type=template&id=728848b8&scoped=true&ts=true"
import script from "./xjllb.vue?vue&type=script&lang=ts"
export * from "./xjllb.vue?vue&type=script&lang=ts"

import "./xjllb.vue?vue&type=style&index=0&id=728848b8&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728848b8"]])

export default __exports__